import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import isToday from 'dayjs/plugin/isToday';
import isoWeek from 'dayjs/plugin/isoWeek';
import { ConversationMediaType } from "@/types/ConversationTypes";
import { DeviceTypes } from "@/types/ConfigTypes";
const REGEXP_STRONG = /\*(.*?)\*/g;
const REGEXP_ITALIC = /_(.*?)_/g;
dayjs.extend(relativeTime);
dayjs.extend(isToday);
dayjs.extend(isoWeek);
export const delay = (ms = 0) => new Promise(res => setTimeout(res, ms));
export const humanizeDate = date => {
    return dayjs(date).fromNow();
};
export const humanizeDateByTS = ts => {
    return dayjs.unix(ts).fromNow();
};
export const formatMessageTime = date => {
    let dateObj;
    if (typeof date === 'number') {
        dateObj = dayjs.unix(date);
    }
    else {
        dateObj = date;
        // assume it's a date object
    }
    if (dayjs(dateObj).isToday()) {
        return dayjs(dateObj).format('H:mm');
    }
    else if (dayjs(dateObj).isoWeek() === dayjs().isoWeek()) {
        return dayjs(dateObj).format('ddd H:mm');
    }
    return humanizeDate(dateObj);
};
// export const formatStandardDate = date => dayjs(date).format('DD MMM, YYYY');
// export const formatStandardTime = date =>
//     dayjs(date).format('DD MMM YYYY, hh:mm A');
export const log = console.log;
// export const parseJSON = jsonString => {
//     try {
//         return JSON.parse(jsonString);
//     } catch (err) {
//         console.error('Failed parsing JSON');
//         return null;
//     }
// };
export const constants = {
    loadingAnimationDuration: 2000,
};
export const isOnlyEmojis = str => str.replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g, '') === "";
export const parseUrls = string => {
    if (!string)
        return;
    const urlRegex = new RegExp("((?:(http|https|Http|Https|rtsp|Rtsp):\\/\\/(?:(?:[a-zA-Z0-9\\$\\-\\_\\.\\+\\!\\*\\'\\(\\)" +
        '\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,64}(?:\\:(?:[a-zA-Z0-9\\$\\-\\_' +
        "\\.\\+\\!\\*\\'\\(\\)\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,25})?\\@)?)?" +
        '((?:(?:[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}\\.)+' + // named host
        '(?:' + // plus top level domain
        '(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])' +
        '|(?:biz|b[abdefghijmnorstvwyz])' +
        '|(?:cat|com|coop|c[acdfghiklmnoruvxyz])' +
        '|d[ejkmoz]' +
        '|(?:edu|e[cegrstu])' +
        '|f[ijkmor]' +
        '|(?:gov|g[abdefghilmnpqrstuwy])' +
        '|h[kmnrtu]' +
        '|(?:info|int|i[delmnoqrst])' +
        '|(?:jobs|j[emop])' +
        '|k[eghimnrwyz]' +
        '|l[abcikrstuvy]' +
        '|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])' +
        '|(?:name|net|n[acefgilopruz])' +
        '|(?:org|om)' +
        '|(?:pro|p[aefghklmnrstwy])' +
        '|qa' +
        '|r[eouw]' +
        '|s[abcdeghijklmnortuvyz]' +
        '|(?:tel|travel|t[cdfghjklmnoprtvwz])' +
        '|u[agkmsyz]' +
        '|v[aceginu]' +
        '|w[fs]' +
        '|y[etu]' +
        '|z[amw]))' +
        '|(?:(?:25[0-5]|2[0-4]' + // or ip address
        '[0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\\.(?:25[0-5]|2[0-4][0-9]' +
        '|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1]' +
        '[0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}' +
        '|[1-9][0-9]|[0-9])))' +
        '(?:\\:\\d{1,5})?)' + // plus option port number
        '(\\/(?:(?:[a-zA-Z0-9\\;\\/\\?\\:\\@\\&\\=\\#\\~' + // plus option query params
        "\\-\\.\\+\\!\\*\\'\\(\\)\\,\\_])|(?:\\%[a-fA-F0-9]{2}))*)?" +
        '(?:\\b|$)');
    return string.replace(urlRegex, matched => {
        let url = matched;
        if (!url.includes('http'))
            url = 'https://' + url;
        return `<a href="${url}" target="_blank">${matched}</a>`;
    });
};
export const isEmail = value => {
    let input = document.createElement('input');
    input.type = 'email';
    input.required = true;
    input.value = value;
    const result = typeof input.checkValidity === 'function'
        ? input.checkValidity()
        : /\S+@\S+\.\S+/.test(value);
    input = null;
    return result;
};
export const getWALink = (phone, text = '', deviceType = DeviceTypes.MOBILE) => {
    if (!phone)
        return false;
    if (deviceType === DeviceTypes.MOBILE) {
        return 'https://api.whatsapp.com/send/?phone=' + phone.replace('+', '') + '&type=phone_number&text=' + text;
    }
    else if (deviceType === DeviceTypes.DESKTOP) {
        return 'https://api.whatsapp.com/send/?phone=' + phone.replace('+', '') + '&type=phone_number&text=' + text;
    }
};
export const isPhoneNumber = value => {
    return /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g.test(`${value}`);
};
export const generateRandomNumber = (start, amount) => {
    return Math.floor(Math.random() * amount) + start;
};
export const getMediaTypeByMimeType = mimetype => {
    switch (mimetype) {
        case 'image/png':
        case 'image/jpg':
        case 'image/jpeg':
        case 'image/gif':
        case 'image/heic':
            return ConversationMediaType.IMAGE;
        case 'video/mp4':
            return ConversationMediaType.VIDEO;
        default:
            return ConversationMediaType.FILE;
    }
};
export const encodeHTML = str => {
    if (!str)
        return;
    return str.replace(/[\u00A0-\u9999<>&]/g, function (i) {
        return '&#' + i.charCodeAt(0) + ';';
    });
};
export const parseMarkdown = str => {
    return str
        .replace(REGEXP_STRONG, '<strong>$1</strong>')
        .replace(REGEXP_ITALIC, '<em>$1</em>');
};
